
// year titles
class YearTitles {
  static from(array) {
    console.log("YEAR FROM", array)
    var values = []
    if (array != undefined) {
      values = array.map(object => {
        return new YearTitles(object)
      });
    }

    return values
  }

  constructor(initializer) {
    this.value = initializer.value;
    this.title = initializer.title;
  }

  static KEY_STRING = "year_titles"
}

// outcome config
class OutcomeConfiguration {
  static from(object) {
    try {
      return new OutcomeConfiguration(object);
    } catch (err) {
      console.log("error - no criteria", err);
      return err;
    }
  }

  constructor(initializer) {
    this.id = initializer.id;
    this.active = initializer.values.active;
  }

  valuesAsJSON() {
    return JSON.stringify({
      active: this.active
    });
  }

  //static KEY_STRING = "outcome_config"
}

// lesson form fields
class Field {
  static from(object) {
    try {
      return new Field(object);
    } catch (err) {
      console.log("error - no field", err);
      return err;
    }
  }

  constructor(initializer) {
    this.name = initializer.name;
    this.value = initializer.value;
    this.order = initializer.order;
    this.used = initializer.used;
    this.protect = initializer.protect;
    this.model = initializer.model;
    this.filebased = initializer.filebased
    this.popover = initializer.popover
    this.product = initializer.product
    this.crossOrder = initializer.crossOrder
    this.icon = initializer.icon

  }
}

class Fields {
  static from(object) {
    try {
      return new Fields(object);
    } catch (err) {
      console.log("error - no criteria", err);
      return err;
    }
  }


  static from(array) {
    var values = Fields.defaultValues()
    if (array != undefined) {
      values = array.map(object => {
        return Field.from(object)
      });
    }

    return _.orderBy(values, ["order", "name"]);
  }


  orderedFields(data) {
    let values = data.map(field => {
      return Field.from(field);
    });
    return _.orderBy(values, ["order", "name"]);
  }

  static defaultValues() {
    return [
      Field.from({ name: "Outline", order: 1, used: true, protect: true, model: "outline", filebased: true, popover: false, product: "all", crossOrder: 1, icon: 'fa-info-circle'  }),
      Field.from({ name: "Introduction", order: 2, used: true, model: "introduction", popover: true, product: "all", crossOrder: 7, icon: "fa-sun"  }),
      Field.from({ name: "Warm-Up", order: 3, used: true, model: "warmup", popover: false, product: "all", crossOrder: 8, icon: "fa-temperature-high"  }),
      Field.from({
        name: "Main Session",
        order: 4,
        used: true,
        protect: true,
        model: "main-session",
        filebased: true,
        popover: false, product: "all", crossOrder: 9, icon: "fa-temperature-high" 
        
      }),
      Field.from({ name: "Game Session", order: 5, used: true, model: "game-session", popover: false, product: "pe", icon: "fa-futbol"  }),
      Field.from({ name: "Competition", order: 6, used: false, model: "competition", popover: false, product: "all" , crossOrder: 10 }),
      Field.from({ name: "Performance", order: 7, used: false, model: "performance", popover: false, product: "pe" }),
      Field.from({ name: "Health & Wellbeing", order: 8, used: false, model: "health", popover: false, product: "pe" }),
      Field.from({ name: "Collaboration", order: 9, used: false, model: "collaboration", popover: false, product: "pe" }),
      Field.from({ name: "Conclusion", order: 10, used: true, model: "conclusion", popover: false, product: "all", crossOrder: 10, icon: "fa-flag"  }),
      Field.from({ name: "Activities", order: 11, used: true, model: "activities", popover: true, product: "pe" , icon: " fa-running"  }),
      Field.from({ name: "Overview", order: 3, used: true, model: "overview", popover: false, product: "all", crossOrder: 3, icon: "fa-plane"  }),
      Field.from({ name: "Prior Knowledge", order: 5, used: true, model: "prior_knowledge", popover: false, product: "all", crossOrder: 5, icon: " fa-long-arrow-alt-left"  }),
      Field.from({ name: "Vocabulary", order: 6, used: true, model: "vocab", popover: false, product: "all", crossOrder: 6, icon: "fa-mail-bulk"  }),
      Field.from({ name: "Post Knowledge", order: 11, used: true, model: "post_knowledge", popover: false, product: "all", crossOrder: 11 , icon: " fa-long-arrow-alt-right" }),
      Field.from({ name: "Adaptive Teaching Ideas", order: 12, used: true, model: "adaption", popover: false, product: "all", crossOrder: 12, icon: "fa-cogs"  }),
      Field.from({ name: "Misconceptions", order: 4, used: true, model: "misconception", popover: false, product: "all", crossOrder: 4, icon: "fa-exclamation-circle"  }),
         Field.from({ name: "Lesson Prep", order: 4, used: true, model: "preparation", popover: false, product: "cross", crossOrder: 2, icon: "fa-pizza-slice"  }),
    ];
  }


  static KEY_STRING = "course_fields"
}

export { Fields, OutcomeConfiguration, YearTitles };
